<div *ngIf="isLoading">
  <router-outlet></router-outlet>
</div>
